import React from "react";
import Table from "../../../../../../common/element/Table";
import moment from "moment";

const { Tr, Th, Td, THead, TBody } = Table;

const WeeklyClosuresList = ({ rows = [] }) => {
  const formatDate = (value, format = "DD/MM/YYYY") =>
    value ? moment(value).format(format) : "-";

  if (!rows.length) {
    return (
      <div className="border border-gray-200 rounded-lg p-6 text-center text-sm text-gray-500">
        No weekly closures found for the selected criteria.
      </div>
    );
  }

  return (
    <div className="overflow-hidden border rounded-lg border-gray-200">
      <Table>
        <THead>
          <Tr>
            <Th>Provider</Th>
            <Th>Provider type</Th>
            <Th>Renewal due</Th>
            <Th>Inactive on</Th>
            <Th>Days overdue</Th>
            <Th>ABN/NZBN</Th>
          </Tr>
        </THead>
        <TBody>
          {rows.map((row, index) => (
            <Tr key={row?.subscription_id ?? index}>
              <Td>{row?.provider_trading_name ?? "-"}</Td>
              <Td>{row?.provider_type_name ?? "-"}</Td>
              <Td>{formatDate(row?.renewal_due_date)}</Td>
              <Td>{formatDate(row?.inactive_on, "DD/MM/YYYY HH:mm")}</Td>
              <Td>
                {row?.days_overdue_at_inactive != null
                  ? row.days_overdue_at_inactive
                  : "-"}
              </Td>
              <Td>{row?.provider_abn_nzbn ?? "-"}</Td>
            </Tr>
          ))}
        </TBody>
      </Table>
    </div>
  );
};

export default WeeklyClosuresList;
